import { createAction, Action } from 'redux-actions';

import { actionTypePrefix } from './constants';
import { CommentPublisher, CommentPublisherResult } from './types';

export const resetEditorPublishResults: (editorId) => Action<any> =
  createAction(
    `${actionTypePrefix}/RESET_EDITOR_PUBLISH_RESULTS`,
    editorId => ({ editorId })
  );

export const publishComment = createAction(
  `${actionTypePrefix}/PUBLISH_COMMENT`,
  (publisher: CommentPublisher) => publisher
);

export const publishCommentSuccess = createAction(
  `${actionTypePrefix}/PUBLISH_COMMENT_SUCCESS`,
  (result: CommentPublisherResult) => result
);

export const publishCommentFailure = createAction(
  `${actionTypePrefix}/PUBLISH_COMMENT_FAILURE`,
  (result: CommentPublisherResult) => result
);

export const focusEditor = createAction(
  `${actionTypePrefix}/FOCUS_EDITOR`,
  (editorId: string) => ({
    editorId,
  })
);

export const focusEditorWithScroll = createAction(
  `${actionTypePrefix}/FOCUS_EDITOR_WITH_SCROLL`,
  (editorId: string, smoothScroll: boolean) => ({
    editorId,
    smoothScroll,
  })
);

export const focusDone = createAction(
  `${actionTypePrefix}/FOCUS_DONE`,
  (editorId: string) => ({
    editorId,
  })
);
